import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import styled from "styled-components";

// @ts-ignore - JS コンポーネント（型定義なし）
import { useGetCurrentUserQuery } from "../../app/accounts/authuser";
// @ts-ignore - JSX コンポーネント（型定義なし）
import TitleBlock from "../../components/block/TitleBlock";
import SwitchComponent from "../../components/form-item/SwitchComponent";
import SvgLoadingAnimation from "../../components/loading";

import RolesManager from "./components/RolesManager";
import RoleTagsManager from "./components/RoleTagsManager";
import CreatorRolesManager from "./components/CreatorRolesManager";

type TabKey = "creator-roles" | "roles" | "tags";

interface TabMeta {
  value: TabKey;
  label: string;
  description: string;
}

const TABS: TabMeta[] = [
  {
    value: "creator-roles",
    label: "ロール × ユーザー",
    description: "ロールに紐付くユーザーの追加・削除を行います",
  },
  {
    value: "roles",
    label: "ロール",
    description: "ロール（accounts_role）を作成・編集・削除します",
  },
  {
    value: "tags",
    label: "ロールタグ",
    description: "ロールタグ（accounts_roletag）を作成・編集・並び替えします",
  },
];

const PageWrapper = styled.div.attrs({
  className: "u-col u-w100 u-gap24",
})`
  padding: 24px 16px 80px;
  max-width: 960px;
  margin: 0 auto;
`;

const Roles: React.FC = () => {
  const { data: currentUser, isLoading } = useGetCurrentUserQuery();
  const [activeTab, setActiveTab] = useState<TabKey>("creator-roles");

  if (isLoading) {
    return <SvgLoadingAnimation />;
  }

  const role: string | undefined = currentUser?.data?.role;
  if (role !== "MANAGER") {
    return <Navigate to="/projects" replace />;
  }

  const activeTabMeta =
    TABS.find((t) => t.value === activeTab) ?? TABS[0];

  return (
    <PageWrapper>
      <TitleBlock title="ロール管理" description={activeTabMeta.description} />

      <SwitchComponent
        value={activeTab}
        options={TABS.map((t) => ({ label: t.label, value: t.value }))}
        onChange={(next: TabKey | null) => {
          if (next) setActiveTab(next);
        }}
      />

      <div className="u-col u-w100 u-gap16">
        {activeTab === "creator-roles" && <CreatorRolesManager />}
        {activeTab === "roles" && <RolesManager />}
        {activeTab === "tags" && <RoleTagsManager />}
      </div>
    </PageWrapper>
  );
};

export default Roles;
